export const getUserNames = (fullname: string) => {
  const nameSplitted = fullname
    .split(" ")
    .filter((name) => name !== "" && name !== undefined && name !== null);

  const first_name = nameSplitted[0];
  const last_name = nameSplitted[nameSplitted?.length - 1];
  const display_name = fullname;

  return {
    first_name,
    last_name,
    display_name,
  };
};
